import { LegendProps } from 'recharts'
import styles from './Charts.module.scss'

export const CustomLegend = (props: LegendProps) => {
    const windowWidth = window.innerWidth
    return <div className={styles.legend}>
        <p className={`${styles.adjusted} ${styles.legendBlock}`}>
            {/* {windowWidth > 768 ? 'Adjusted revenue with a new website' : 'New website'} */}
            After
        </p>
        <p className={`${styles.current} ${styles.legendBlock}`}>
            {/* {windowWidth > 768 ? 'Revenue with the current website' : 'Current website'} */}
            Before
        </p>
    </div>
}